import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { FormControlService } from "../form-control.service";
import { ControlValueAccessorImpl } from "../ng-material-impl/control-value-accessor.impl";
import createControlValueAccessorProvider from "../utils/create-control-value-accessor-provider";
import { TextAreaFormControlService } from "./text-area-form-control.service";


@Component({
  selector: 'ss-text-area-form-control',
  templateUrl: './text-area-form-control.component.html',
  styleUrls: ['./text-area-form-control.component.css'],
  providers: [
    FormControlService,
    TextAreaFormControlService,
    createControlValueAccessorProvider(TextAreaFormControlComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextAreaFormControlComponent extends ControlValueAccessorImpl<string> implements OnInit {

  readonly statusObs = this._formControlService.controlStatusObs;

  readonly minRowsSubject = this._textAreaFormControlService.minRowsSubject
  @Input() get minRows() {
    return this.minRowsSubject.value
  }
  set minRows(value) {
    this.minRowsSubject.next(value)
  }

  readonly maxRowsSubject = this._textAreaFormControlService.maxRowsSubject
  @Input() get maxRows() {
    return this.maxRowsSubject.value
  }
  set maxRows(value) {
    this.maxRowsSubject.next(value)
  }

  constructor(
    private readonly _textAreaFormControlService: TextAreaFormControlService
  ) {

    super()
  }

  ngOnInit(): void {
  }

}
